import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, timer, Subscription } from 'rxjs';
import { AlertAnalyzesService } from './alert-analyzes.service';
import { ActivatedRoute, Router } from '@angular/router';
import { switchMap, tap } from 'rxjs/operators';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { AlertAnalyzesGroupService } from './alert-analyzes-group.service';
import { AlertAnalyzesHistoryService } from './alert-analyzes-hisory.service';
import { WeatherService } from 'src/app/share/services/weather.service';

@Component({
  selector: 'app-alert-analyzes',
  templateUrl: './alert-analyzes.component.html',
  styleUrls: ['./alert-analyzes.component.scss']
})
export class AlertAnalyzesComponent implements OnInit, OnDestroy {

  viewState$: Observable<any>;
  viewHistState$: Observable<any>;
  viewWeatherState$: Observable<any>;

  groupsSubscr: Subscription;
  selectedPeriod: number;
  periodSelect: Array<any>;
  workDate: string;
  historyListButtonText: string;
  historyListCountText: string;
  recordsCount: number;
  extendWeather: boolean;

  maximumHistoryAlerts: number;

  public groupSelect: IGroupSelect[] = [];
  selectedGroup = '';

  public datePickerOptions: IMyOptions = {
    firstDayOfWeek: 'mo',
    dateFormat: 'mm/dd/yyyy',
    disableUntil: { year: 2019, month: 11, day: 11 }, // Disable dates backward starting from the given date.
  };

  selectedDate = { date: { year: 0, month: 0, day: 0 } };

  filterTimes: string;

  public chartType: string;

  public chartColors: Array<any> = [
    {
      backgroundColor: 'transparent',
      borderColor: 'rgba(0, 10, 130, .7)',
      borderWidth: 3
    },
    {
      backgroundColor: 'transparent',
      borderColor: 'rgba(200, 99, 132, .7)',
      borderWidth: 3
    }
  ];

  public maxWaitTime: string[];

  public chartOptions: any = {
    responsive: true,
    barRoundness: 0,
    scales: {
      xAxes: [{
          ticks: {
              // Include a dollar sign in the ticks
              callback: function(value, index, values) {
                  return value && value.toString().length >= 2 ? value.toString().substring(0, 2) : "";
              }
          }
      }]
    },
    tooltips: {
      mode: 'label',
      callbacks: {
        title: function(tooltipItem, data) {
            return(data.labels[tooltipItem[0].index] || '');
          }
      }
    }
  };

  constructor(private data: AlertAnalyzesService, private route: ActivatedRoute, private groups: AlertAnalyzesGroupService,
    private history: AlertAnalyzesHistoryService, private router: Router, private weather: WeatherService) {
    var today = new Date();
    this.workDate = today.getMonth() + 1 + "/" + today.getDate() + "/" + today.getFullYear();
    this.selectedDate = { date: { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() } };
    this.maximumHistoryAlerts = 3;
    this.chartType = "line";
    this.selectedPeriod = 1;
    this.historyListButtonText = "More Items...";
    this.filterTimes = "";
    this.historyListCountText = "";
    this.recordsCount = 0;
    this.extendWeather = false;
  }

  ngOnInit() {
    this.groupSelect = [
      { value: "allgroups", label: "All Groups" }
    ];
    this.periodSelect = [
      { value: 1, label: '1 Hour' },
      { value: 2, label: '2 Hours' },
      { value: 3, label: '3 Hours' },
      { value: 4, label: '4 Hours' },
      { value: 5, label: '5 Hours' },
      { value: 6, label: '6 Hours' },
    ];

    this.groupsSubscr = this.groups.getGroupsAlertDate().subscribe((d) => {
      d.groups.forEach(g => {
        this.groupSelect = [...this.groupSelect, { value: g.Code, label: g.Title }];
      })
    });
    this.selectedGroup = "allgroups";

    this.viewState$ = timer(0, 900000 /* 15min */).pipe(
      switchMap(() => this.data.getEmailSmsAlertDate(this.workDate, this.selectedGroup, this.selectedPeriod))
    );

    this.viewHistState$ = timer(0, 2000 /* 2sec */).pipe(
      switchMap(() => this.history.getEmailSmsAlertHistoryDate(this.workDate, this.selectedGroup, this.filterTimes)),
      tap(r => {
        this.recordsCount = r.alerts.length;
        this.updateHistoryListCountText();
      })
    );

    this.viewWeatherState$ = this.weather.getWeatherData(this.workDate, '2695_PC', 1);
  }

  ngOnDestroy() {
    if (!this.groupsSubscr.closed)
      this.groupsSubscr.unsubscribe();
  }

  showHeader() {
    var x = document.getElementById("pageheader");

    x.style.display = x.style.display === "none" ? "block" : "none";

    var t = document.getElementById("headTriger");
    t.style.top = x.style.display === "none" ? "10px" : "60px";

    var i = document.getElementById("headTrigerIcon");
    i.className = x.style.display === "none" ? "fa fa-arrow-down" : "fa fa-arrow-up";
  }
  getSelectedGroupValue(event: any) {
    this.selectedGroup = event;

    this.refreshView();
  }

  getSelectedDateValue(event: Date) {
    var date = new Date(event);
    this.workDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();

    this.refreshView();
  }

  triggerAlertHistoryRows() {
    this.maximumHistoryAlerts = this.maximumHistoryAlerts === 3 ? 10000 : 3;
    this.historyListButtonText = this.maximumHistoryAlerts === 3 ? "More Items..." : "Less Items...";
    this.updateHistoryListCountText();
  }

  updateHistoryListCountText() {
    this.historyListCountText = this.maximumHistoryAlerts === 3
      ? this.recordsCount <= 3
        ? this.recordsCount.toString() + " of " + this.recordsCount.toString()
        : "3 of " + this.recordsCount.toString()
      : this.recordsCount.toString() + " of " + this.recordsCount.toString();
  }
  getSelectedTimePeriodValue(event: any) {
    this.selectedPeriod = event;
    this.refreshView();
  }

  refreshView() {
    this.refreshAlerts();
    this.refreshHistory();
    this.refreshWeather();
  }

  refreshAlerts() {
    this.viewState$ = timer(0, 900000 /* 15min */).pipe(
      switchMap(() => this.data.getEmailSmsAlertDate(this.workDate, this.selectedGroup, this.selectedPeriod))
    );
  }

  refreshHistory() {
    this.viewHistState$ = timer(0, 2000 /* 2sec */).pipe(
      switchMap(() => this.history.getEmailSmsAlertHistoryDate(this.workDate, this.selectedGroup, this.filterTimes)),
      tap(r => {
        this.recordsCount = r.alerts.length;
        this.updateHistoryListCountText();
      })
    );
  }

  refreshWeather() {
    this.viewWeatherState$ = this.weather.getWeatherData(this.workDate, '2695_PC', 1);
  }

  public chartClicked(e: any): void {
    if (e.active.length > 0) {
      const chart = e.active[0]._chart;
      const activePoints = chart.getElementAtEvent(e.event);
      if (activePoints.length > 0) {
        // get the internal index of slice in pie chart
        const clickedElementIndex = activePoints[0]._index;
        this.filterTimes = chart.data.labels[clickedElementIndex];
        this.maximumHistoryAlerts === 3 ? this.triggerAlertHistoryRows() : null;
        this.refreshHistory();
      }
    }
    else {
      this.refreshHistoryList();
    }
  }

  refreshHistoryList() {
    if (this.filterTimes.length === 0)
      return;
    this.filterTimes = "";
    this.maximumHistoryAlerts !== 3 ? this.triggerAlertHistoryRows() : null;
    this.refreshHistory();
  }
  public chartHovered(e: any): void { }

  showDetails(correlationId: string) {
    this.router.navigateByUrl("dashboards/alert-detail/" + correlationId);
  }

  triggerExtendedView() {
    this.extendWeather = this.extendWeather ? false : true;
  }

  goPrevDay() {
    this.setDate(-1);
  }

  goNextDay() {
    this.setDate(1);
  }

  setDate(direction: number) {
    var date = new Date(this.workDate);
    date.setDate(date.getDate() + (1 * direction));
    this.workDate = date.getMonth() + 1 + "/" + date.getDate() + "/" + date.getFullYear();
    this.selectedDate = { date: { year: date.getFullYear(), month: date.getMonth() + 1, day: date.getDate() } };
    this.maximumHistoryAlerts = 3;
    this.historyListButtonText = "More Items...";

    this.refreshView();
  }
}

export interface IGroupSelect {
  value: string;
  label: string;
}
